import { createBrowserRouter } from "react-router-dom";
import Home from "../pages/Home";
import FindClaim from "../pages/FindPlan";
import RouteNames from "./type";
import SearchByWarrantyNumber from "../pages/FindPlan/SearchByWarrantyNumber";
import SearchByPersonalInfo from "../pages/FindPlan/SearchByPersonalInfo";
import NoWarrantyFound from "../pages/FindPlan/NoWarrantyFound";
import Warrntyid from "../pages/warrntyid";
import ContactService from "../pages/ContactService";
import CreateAceClaim from "../pages/CreateAceClaim";
import CreateAce2Claim from "../pages/CreateAce2Claim";
import SelectPlan from "../pages/FindPlan/SelectPlan";
import AddAce2WarrantyItem from "../pages/AddAce2WarrntyItem";
import CancellationService from "../pages/CancellationService";
import ErrorPage from "../components/ErrorPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <ErrorPage />,
  },
  {
    path: RouteNames.SELECT_SEARCH_METHOD,
    element: <FindClaim />,
    errorElement: <ErrorPage />,
  },
  {
    path: RouteNames.ADD_ACE2_WARRNTY_ITEM,
    element: <AddAce2WarrantyItem />,
    errorElement: <ErrorPage />,
  },
  {
    path: RouteNames.WARRANTY_NUMBER,
    element: <SearchByWarrantyNumber />,
    errorElement: <ErrorPage />,
  },
  {
    path: RouteNames.NO_WARRANTY_FOUND,
    element: <NoWarrantyFound />,
    errorElement: <ErrorPage />,
  },
  {
    path: RouteNames.SEARCH_BY_PERSONAL_INFO,
    element: <SearchByPersonalInfo />,
    errorElement: <ErrorPage />,
  },
  {
    path: RouteNames.CREATE_ACE_CLAIM,
    element: <CreateAceClaim />,
    errorElement: <ErrorPage />,
  },
  {
    path: RouteNames.CREATE_ACE2_CLAIM,
    element: <CreateAce2Claim />,
    errorElement: <ErrorPage />,
  },
  {
    path: RouteNames.SELECT_PLAN,
    element: <SelectPlan />,
    errorElement: <ErrorPage />,
  },
  {
    path: RouteNames.CONTACT_SERVICE,
    element: <ContactService />,
    errorElement: <ErrorPage />,
  },
  {
    path: RouteNames.CANCELLATION_SERVICE,
    element: <CancellationService />,
    errorElement: <ErrorPage />,
  },
  {
    path: RouteNames.WARRNTY_ID,
    element: <Warrntyid />,
    errorElement: <ErrorPage />,
  },
]);
